import Cookies from 'universal-cookie';
import { logout } from '../../services/Users';

/**
 * Shared logout handler that follows the standard logout flow:
 * 1. Call logout API and wait for 200 success response
 * 2. Clear all auth state (claims, cookies, localStorage, sessionStorage)
 * 3. Redirect to auth page
 *
 * @param {string} csrfToken - CSRF token for the logout API call
 * @param {Function} setAuthClaims - Function to clear auth claims from context
 * @param {Function} redirectCallback - Function to handle redirect (e.g., (path, state) => navigate(path, { state }))
 * @param {Function} onComplete - Optional callback after logout completes
 * @param {Object} redirectState - Optional state to pass to the auth page (e.g. { logoutReason: 'session_expired' })
 */
export const performLogout = async (csrfToken, setAuthClaims, redirectCallback, onComplete = null, redirectState = null) => {
    try {
        if (csrfToken) {
            try {
                const response = await logout(csrfToken);

                // Check if we got a successful response (200-299)
                if (!response || response.status < 200 || response.status >= 300) {
                    // Continue with logout even if status is not 200
                }
            } catch (error) {
                // Continue with logout even if API call fails
            }
        }

        // Clear auth state
        // Remove auth token from session
        setAuthClaims(null);

        // Remove auth token from cookie
        const cookies = new Cookies();
        cookies.remove("claims");

        // Clear localStorage
        localStorage.removeItem('authClaims');
        localStorage.removeItem('user');

        // Clear sessionStorage
        sessionStorage.removeItem('sessionData');

        // Call optional completion callback
        if (onComplete) {
            onComplete();
        }

        // Redirect to login page
        if (redirectCallback) {
            redirectCallback('/auth', redirectState);
        } else {
            // Fallback: try to use React Router if available, otherwise use window.location
            // This should rarely happen if redirectCallback is always provided
            if (window.history && window.history.pushState) {
                window.history.pushState(null, '', '/auth');
                window.dispatchEvent(new PopStateEvent('popstate'));
            } else {
                window.location.href = '/auth';
            }
        }
    } catch (error) {
        // Even if there's an error, try to clear state and redirect
        setAuthClaims(null);
        const cookies = new Cookies();
        cookies.remove("claims");
        localStorage.removeItem('authClaims');
        localStorage.removeItem('user');
        sessionStorage.removeItem('sessionData');

        if (redirectCallback) {
            redirectCallback('/auth', redirectState);
        } else {
            // Fallback: try to use React Router if available, otherwise use window.location
            if (window.history && window.history.pushState) {
                window.history.pushState(null, '', '/auth');
                window.dispatchEvent(new PopStateEvent('popstate'));
            } else {
                window.location.href = '/auth';
            }
        }
    }
};
